import * as React from 'react';
import { Row, Col, Input, Button, Icon } from 'antd';
import '../../css/OrganizationAddEdit.scss';
import strings from '../../eyeguide-localization/user/string.user.addedit';
import service from '../../service/apolloclient.service';
import Auth from '../common/auth';
import Utils from '../common/utils';

interface IContentTwoProps {
    handleNextClick: any;
    handlePrevClick: any;
    account: any;
}

/**
 * State definition
 */
interface IContentTwoState {
    classesWithErr: string;
    classesWithoutErr: string;
    errorusername: boolean;
    errorfirstname: boolean;
    errorlastname: boolean;
    erroremail: boolean;
    errorphone: boolean;
    showUserCheck: boolean;
    userCheckType: string;
    userCheckColor: string;
    username:       string;
    firstname:      string;
    lastname:       string;
    email:          any ;
    phone: string;
    user: any;
}

export default class ContentOne extends React.Component<IContentTwoProps, IContentTwoState> {

    constructor(props: IContentTwoProps) {
        super(props); 
        this.state = {
            classesWithErr : 'fill errorHighlight',
            classesWithoutErr: 'fill',
            errorusername: false,
            errorfirstname: false,
            errorlastname: false,
            erroremail: false,
            errorphone: false,
            showUserCheck: false,
            userCheckType: '',
            userCheckColor: '',
            username : this.props.account.username,
            firstname : this.props.account.firstname,
            lastname : this.props.account.lastname,
            email : this.props.account.email,
            phone: this.props.account.phone,
            user: []
        };
    }

    render() {
        return (
            <div className="content">
                <Row className="row">
                    <Col xs={1} sm={1} md={2} lg={5} xl={4} />
                    <Col xs={8} sm={8} md={5} lg={3} xl={5} className="labelFrame">
                        <div className="label">
                            <span> {strings.lsUsrNameTxt}
                                <span className="labelReq"> * </span>
                            :</span>
                        </div>
                    </Col>
                    <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                        <Input 
                            value={this.state.username}
                            onChange={(val) => this.setState({username: val.target.value})}
                            className={this.state.errorusername ? 
                                    this.state.classesWithErr : this.state.classesWithoutErr}
                            placeholder="e.g. jjohnson" 
                            onBlur={() => this.validateUsername()}
                            disabled={this.state.user instanceof Array && 
                                this.state.user.length === 0 ? false : true}
                            autoFocus={true}
                        />
                    </Col>
                    <Col xs={1} sm={1} md={2} lg={5} xl={4}>
                        {this.state.showUserCheck ? 
                        <div>
                        <Col xs={1} sm={1} md={2} lg={5} xl={5}>
                        <Icon 
                            style={{paddingLeft: '12px', 
                                    paddingTop: '5px' , 
                                    color: this.state.userCheckColor , 
                                    fontSize: '19px'}}
                            type={this.state.userCheckType}
                        /> </Col>
                        <Col xs={1} sm={1} md={2} lg={19} xl={19}>
                        {this.state.userCheckColor === 'red' ? 
                            <span className="hyphenate"> {strings.lsUsrAlreadyExistTxt} 
                            </span> : ''}
                        </Col>
                        </div>
                        : ''}
                    </Col>                   
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={2} lg={5} xl={4} />
                    <Col xs={8} sm={8} md={5} lg={3} xl={5} className="labelFrame">
                        <div className="label">
                            <span>   {strings.lsFNameTxt}      
                            <span className="labelReq"> * </span>
                            :</span>
                        </div>
                    </Col>
                    <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                        <Input 
                            value={this.state.firstname}
                            onChange={(val) => this.setState({firstname: val.target.value})}
                            className={this.state.errorfirstname ? 
                                    this.state.classesWithErr : this.state.classesWithoutErr}
                            placeholder="e.g. Johnny"
                        />
                    </Col>
                    <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={2} lg={5} xl={4} />
                    <Col xs={8} sm={8} md={5} lg={3} xl={5} className="labelFrame">
                    <div className="label">
                        <span> {strings.lsLNameTxt}
                            <span className="labelReq"> * </span>
                        :</span>
                    </div>
                    </Col>
                    <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                        <Input 
                            value={this.state.lastname} 
                            onChange={(val) => this.setState({lastname: val.target.value})}
                            className={this.state.errorlastname ? 
                                    this.state.classesWithErr : this.state.classesWithoutErr}
                            placeholder="eg Thomas" 
                        />
                    </Col>
                    <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={2} lg={5} xl={4} />
                    <Col xs={8} sm={8} md={5} lg={3} xl={5} className="labelFrame">
                    <div className="label">
                            <span> {strings.lsEmailTxt}
                                <span className="labelReq"> * </span>
                            :</span>
                    </div>
                    </Col>
                    <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                        <Input
                            value={this.state.email} 
                            onChange={(val) => this.setState({email: val.target.value})}
                            className={this.state.erroremail ? 
                                this.state.classesWithErr : this.state.classesWithoutErr}
                            placeholder="eg johny.thomas@school.edu" 
                        />
                    </Col>
                    <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                </Row>
                <Row className="row">
                    <Col xs={1} sm={1} md={2} lg={5} xl={4} />
                    <Col xs={8} sm={8} md={5} lg={3} xl={5} className="labelFrame">
                    <div className="label">
                            <span> {strings.lsMobilePhTxt}
                                <span className="labelReq"> * </span>
                            :</span>
                    </div>
                    </Col>
                    <Col xs={14} sm={14} md={16} lg={10} xl={9}>
                        <Input
                            value={this.state.phone} 
                            onChange={(val) => this.setState({phone: val.target.value})}
                            className={this.state.errorphone ? 
                                this.state.classesWithErr : this.state.classesWithoutErr}
                            placeholder="eg 0123-456-789" 
                        />
                    </Col>
                    <Col xs={1} sm={1} md={2} lg={6} xl={4}/>
                </Row>
                 <Row>
                    <Col span={12} style={{padding: '10px'}}>
                        <div className="buttonRight"> 
                            <Button 
                                onClick={e => {
                                    if (this.state.user instanceof Array && this.state.user.length === 0 ) {
                                        // this.processUser
                                        // (this.getUserObj(), 1, ''); // 1 for add
                                        let isValid: boolean = true;
                                        isValid = this.getUserObj();
                                        if (isValid !== false) {
                                            this.props.handleNextClick(isValid, 2); 
                                        }
                                    } 
                                }}     
                                type="primary" 
                                style={{width: '100%'}}
                            > 
                            {strings.lsNextTxt} 
                            </Button> 
                        </div>
                    </Col>
                    <Col span={12} style={{padding: '10px'}}>
                        <div className="buttonLeft"> 
                            <Button 
                                    onClick={e => this.props.handlePrevClick(1)} 
                                    type="danger" 
                                    style={{width: '100%'}}
                            > 
                            {strings.lsPrevTxt} 
                            </Button> 
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }

    /**
     * Validates the username provided by user while creating user,
     * by calling the server
     */
    private async validateUsername() {
        console.log('validate', this.state.username !== null && this.state.username !== undefined 
                                ? this.state.username.trim() : '');
        let ser = new service();
        let response: any;
        if (this.state.username !== null && this.state.username !== undefined
                         && this.state.username.trim().length > 0 ) {
            response = await ser.verifyUsername(this.state.username.trim());
            console.log('response', response);
            if (response.status === 0) { // success
                this.setState({
                    showUserCheck: true,
                    userCheckType: 'check-circle', // 'check-circle'
                    userCheckColor: '#4ddb33b0' // '#4ddb33b0'
                });
            } else {
                this.setState({
                    showUserCheck: true,
                    userCheckType: 'close-circle', // 'check-circle'
                    userCheckColor: 'red' // '#4ddb33b0'
                });
            }
        }
    }

    /**
     * Returns user object in json format
     * to be sent to server for processing
     */
    private getUserObj(): any {
        if (this.validateInput() && this.state.userCheckColor !== 'red' ) {
            let inputUser: any = {
                'username': this.state.username !== null ? this.state.username.trim() : '',     
                'firstname': this.state.firstname !== null ? this.state.firstname.trim() : '',
                'lastname': this.state.lastname !== null ? this.state.lastname.trim() : '',
                'email': this.state.email !== null ? this.state.email.trim() : '',
                'phone': this.state.phone != null ? this.state.phone.trim() : '',
                'roleid': Auth.getRoles().ORGANIZATION_ADMIN,
                'organizations': ''
                }; 
            console.log('inputOrg', inputUser); 
            return inputUser;
        } else {
            return false;
        }       
    }
    
    /**
     * Validate input values provided by the user before submitting to server 
     */
    private validateInput(): boolean {
        let isValid: boolean = true;
        let errorusername: boolean = false;
        let errorfirstname: boolean = false;
        let errorlastname: boolean = false;
        let erroremail: boolean = false;
        let errorphone: boolean = false;
        this.state.username !== null && (this.state.username === undefined || this.state.username.trim() === '') ?
                    errorusername = true : errorusername = false;
        this.state.firstname !== null && (this.state.firstname === undefined || this.state.firstname.trim() === '') ?
                    errorfirstname = true : errorfirstname = false;
        this.state.lastname !== null && (this.state.lastname === undefined || this.state.lastname.trim() === '') ?
                    errorlastname = true : errorlastname = false;
        this.state.email !== null && (this.state.email === undefined || 
                    this.state.email.trim() === '') ? erroremail = true 
                    : erroremail = false;
        this.state.phone !== null && (this.state.phone === undefined || 
                    this.state.phone.trim() === '') ? errorphone = true 
                    : errorphone = false;
        erroremail = erroremail ? erroremail : !Utils.validateEmail(this.state.email);
        if (errorusername || errorfirstname || errorlastname || erroremail || errorphone) { 
            isValid = false; 
        }
        this.setState({errorusername, errorfirstname, errorlastname, erroremail, errorphone});
        return isValid;
    }
}


// WEBPACK FOOTER //
// ./src/components/customer/ContentTwo.tsx